import { Observable } from 'rxjs';
import { UserContext } from '../models/context.model';

export abstract class IContextService {
    selectedDomainContext$: Observable<any>;
    selectedOrgContext$: Observable<any>;
    error$: Observable<any>;
    defaultContext: any;
    hasError: boolean;
    abstract setDomainContext(domain: string, value: any): void;
    abstract setOrgDomainContext(domain: string, value: any): void;
    abstract clearContextError();
    abstract getDeviceType(): any;
    abstract clearContext(): void;
    abstract saveLocalStorage(): void;
    abstract isAuthenticated(): boolean;
    abstract setContextError(errorMessage: string, errorCode?: string);
    abstract setDeviceType(deviceType: string);
    abstract setGotoContext(goToContext: any);
    abstract getGotoContext(): any;
    abstract setRouteContext(routerContext: any);
    abstract getRouteContext(): any;
    abstract setUserContext(userContext: UserContext);
    abstract getUserContext(): any;
}
